import { app } from '../../app.module'
app
  // カテゴリテーブルのアクション
  .directive('editCategoryTableActions', () => {
    return {
      restrict: 'EA',
      template: require('./edit-category-table-actions.pug')(),
      controller: ($scope) => {
        $scope.type = 'edit'
        /**
         * cancelSave カテゴリとソート番号をリセット
         * @return {void}
         */
        $scope.cancelSave = function () {
          $scope.category.categoryName = $scope.category.categoryBefore
          $scope.category.sortNo = $scope.category.sortNoBefore
          $scope.type = 'edit'
        }
      },
    }
  })
